import type { FlowTriggers } from "@velizhanin-dev/bot-scenario"
import * as api from "@/entities/bot-builder"
import { draftCache as cache } from "@/entities/bot-builder"
import type { ActionsContext } from "./types"

export function createFlowActions({ enqueue, scenarioId }: ActionsContext) {
	return {
		createFlow: (name: string) =>
			enqueue(
				"Не удалось создать воронку",
				(baseRevision) => api.createFlow(scenarioId, { baseRevision, name }),
				(draft, result) =>
					result.nodes.reduce(
						(next, node) => cache.upsertNode(next, node),
						cache.upsertFlow(draft, result.flow),
					),
			),

		duplicateFlow: (flowId: string) =>
			enqueue(
				"Не удалось создать копию воронки",
				(baseRevision) => api.duplicateFlow(scenarioId, flowId, { baseRevision }),
				(draft, result) =>
					result.edges.reduce(
						(next, edge) => cache.upsertEdge(next, edge),
						result.nodes.reduce(
							(next, node) => cache.upsertNode(next, node),
							cache.upsertFlow(draft, result.flow),
						),
					),
			),

		renameFlow: (flowId: string, name: string) =>
			enqueue(
				"Не удалось переименовать воронку",
				(baseRevision) => api.updateFlow(scenarioId, flowId, { baseRevision, name }),
				(draft, result) => cache.upsertFlow(draft, result.flow),
			),

		setFlowTriggers: (flowId: string, triggers: FlowTriggers | null) =>
			enqueue(
				"Не удалось сохранить запуск воронки",
				(baseRevision) => api.updateFlow(scenarioId, flowId, { baseRevision, triggers }),
				(draft, result) => cache.upsertFlow(draft, result.flow),
			),

		deleteFlow: (flowId: string) =>
			enqueue(
				"Не удалось удалить воронку",
				(baseRevision) => api.deleteFlow(scenarioId, flowId, baseRevision),
				(draft) => cache.removeFlow(draft, flowId),
			),

		setFlowActive: (flowId: string, active: boolean) =>
			enqueue(
				active ? "Не удалось включить воронку" : "Не удалось выключить воронку",
				(baseRevision) => api.updateFlow(scenarioId, flowId, { baseRevision, active }),
				(draft, result) => cache.upsertFlow(draft, result.flow),
			),

		makeFlowMain: (flowId: string) =>
			enqueue(
				"Не удалось сделать воронку основной",
				(baseRevision) => api.updateFlow(scenarioId, flowId, { baseRevision, main: true }),
				(draft, result) => {
					const next = cache.upsertFlow(draft, result.flow)
					return result.previousMain ? cache.upsertFlow(next, result.previousMain) : next
				},
			),
	}
}
